var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5299_1800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6664 13.3351H11.1109C10.8162 13.3351 10.5336 13.218 10.3252 13.0096C10.1168 12.8013 9.99978 12.5186 9.99978 12.224V9.44618C9.99978 9.29884 9.94125 9.15753 9.83706 9.05334C9.73288 8.94916 9.59157 8.89062 9.44423 8.89062H8.88867",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72211 6.66884C9.64844 6.66884 9.57779 6.63957 9.52569 6.58748C9.4736 6.53538 9.44434 6.46473 9.44434 6.39106C9.44434 6.31739 9.4736 6.24673 9.52569 6.19464C9.57779 6.14255 9.64844 6.11328 9.72211 6.11328",
    stroke: "#001184",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72217 6.66884C9.79584 6.66884 9.86649 6.63957 9.91859 6.58748C9.97068 6.53538 9.99995 6.46473 9.99995 6.39106C9.99995 6.31739 9.97068 6.24673 9.91859 6.19464C9.86649 6.14255 9.79584 6.11328 9.72217 6.11328",
    stroke: "#001184",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3346C14.6021 18.3346 18.3332 14.6035 18.3332 10.0013C18.3332 5.39908 14.6021 1.66797 9.99984 1.66797C5.39762 1.66797 1.6665 5.39908 1.6665 10.0013C1.6665 14.6035 5.39762 18.3346 9.99984 18.3346Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5299_1800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.14e80ea3f99e7d3c1a41a129d4b90096.svg";
export { ForwardRef as ReactComponent };